export default __webpack_public_path__ + "static/media/ic-pdf.b21f429e.svg";